import { atom } from 'recoil';

const modalControl = atom({
  key: 'globalModalControl',
  default: {
    isLoginModalOpen: false,
    isPickMealPointModalOpen: false,
    isPickupSettingModalOPen: false,
  },
});

export default modalControl;
